/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from "react";
import { findIndex } from 'lodash';
import { NavLink, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import Badge from '@material-ui/core/Badge';

// import Tooltip from '@material-ui/core/Tooltip';

import { useQuery, useMutation } from "@apollo/client";
import { GET_ALL_PRODUCTS, ADD_TO_CART } from "../../queries";
import { useThemeData } from "../../context/ThemeDataContext";
import PhotoCard from "../photoservice/photoCard";
import UserToolBar from "./userToolBar";
import GeneralButton from "../../components/Buttons";
import { useCallback } from "react";
import {
  LightgalleryProvider,
  // LightgalleryItem,
  // withLightgallery,
  // useLightgallery
} from "react-lightgallery";

/* Album OVERVIEW and photos linking to shop*/
function AlbumPhotos(props) {
  const routeParams = useParams();
  const { album_id } = routeParams;
  const { site_id } = useThemeData().themeData.site;
  const [folderID, setFolderID] = useState(
    props.location.state.album.first_photo_folder_id !== undefined
      ? props.location.state.album.first_photo_folder_id
      : album_id
  );

  const [pageInfo, setPageInfo] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [page, setPage] = useState(0);

  const [data, setData] = useState([]);

  const [updatedSelection, setUpdatedSelection] = useState(false);
  const [disableSelection, setDisableSelection] = useState(false);
  const [disableButton, setDisableButton] = useState(true);

  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedEffect, setSelectedEffect] = useState([]);
  const [selectedQuantities, setSelectedQuantities] = useState([]);

  const [totalCredits, setTotalCredits] = useState(2);
  const [credits, setCredits] = useState(totalCredits);
  const [addCredits] = useState(5);
  

  const {
    error: errorPhotos,
    loading: loadingPhotos,
    data: dataPhotos,
  } = useQuery(GET_ALL_PRODUCTS, {
    variables: {
      site_id: site_id,
      login_name: "",
      folder_id: folderID,
      first: rowsPerPage,
      page: page + 1,
    },
    skip: site_id === null || folderID === null,
  });

  const [createShoppingcart,
    { loading: loadingCreateShoppingCart }]
    = useMutation(ADD_TO_CART
    )


  console.log(dataPhotos);

  useEffect(() => {
    if (!loadingPhotos && !errorPhotos) {
      if (dataPhotos) {

        console.log(dataPhotos);

        setData(dataPhotos.photos.data);
        setPageInfo(dataPhotos.photos.paginatorInfo);
      }
    }
  }, [errorPhotos, dataPhotos, loadingPhotos]);
 
  useEffect(() => {
    if (props.location.state) {
      if (props.location.state.loggedIn === true) {
        GetPhotos(props.location.state.folder_id);
      }
    }
  }, [props.location.state]);

  function handleChangePage(event, value) {
    setPage(value);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(event.target.value);
  }

  function GetPhotos(folderid) {
    setFolderID(folderid);
  }

  useEffect(() => {
    if (updatedSelection === false) {
      const newCredits = totalCredits - selectedPhotos.length;
      setCredits(newCredits);
      setUpdatedSelection(true);
      if (newCredits === 0) {
        setDisableSelection(true)
      } else {
        setDisableSelection(false)
      }
  }
  }, [updatedSelection, selectedPhotos.length, totalCredits])

  function updatePhotoSelection(photo) {
    if (selectedPhotos.find(f => f.id === photo.id) === undefined) {
      setSelectedPhotos(prevState => [...prevState,({ id: photo.id}) ]);
    } else {
      let currentSelection = selectedPhotos;
      let PhotoIndex = findIndex(currentSelection, currentSelection.find(f => f.id === photo.id)); // index
      currentSelection.splice(PhotoIndex, 1);
      setSelectedPhotos(currentSelection);
    }
    setUpdatedSelection(false);
  }

  function addCreditsToCart() {
    const newTotalCredits = addCredits + totalCredits;
    const newCredits = newTotalCredits - selectedPhotos.length;
    setCredits(newCredits);
    setTotalCredits(newTotalCredits);
    setDisableSelection(false)
  }

  function addEffectToProduct(e, product_id, photo_id) {
    const value = e.target.value;
    let new_effect_array = new Set();
    let new_effect_object = {};
    let selectedEffects = Array.from(selectedEffect);
    if (value !== 'null') {
      if (selectedEffects.length === 0) {
        // add object to array 
        new_effect_object = {
          photo_id: photo_id,
          product_id: product_id, 
          effect: e.target.value
        };
        new_effect_array.add(new_effect_object);
        new_effect_array = Array.from(new_effect_array);
        setSelectedEffect(new_effect_array)
      } else {
        // first check if photo_id already exist
        if (selectedEffect.find(p => p.photo_id === photo_id) !== undefined) {
                  // if already exist, replace with new value
                  new_effect_object = {
                    photo_id: photo_id,
                    product_id: product_id, 
                    effect: e.target.value
                  };
                  const existingObjectIndex = findIndex(selectedEffects, selectedEffects.find(f => f.photo_id === photo_id)); 
                  if (existingObjectIndex !== -1) {
                    selectedEffects.splice(existingObjectIndex, 1, new_effect_object);
                    setSelectedEffect(selectedEffects);
                  }
        } else {
              // if not just add object to array
              new_effect_object = {
                photo_id: photo_id,
                product_id: product_id, 
                effect: e.target.value
              };
              let update_effect_array = new Set(selectedEffects);
              update_effect_array.add(new_effect_object);
              update_effect_array = Array.from(update_effect_array);
              setSelectedEffect(update_effect_array);
        }
      }
    } else {
      // replace object if one exist with this photo_id
      if (selectedEffects.find(p => p.photo_id === photo_id) !== undefined) { 
        new_effect_object = {
          photo_id: photo_id,
          product_id: product_id, 
          effect: 'null'
        };
        const existingObjectIndex = findIndex(selectedEffects, selectedEffects.find(f => f.photo_id === photo_id)); 
        selectedEffects.splice(existingObjectIndex, 1, new_effect_object);
        setSelectedEffect(selectedEffects);
      }
    }
  }

  function addQuantityToProduct(e, product_id, photo_id) {
    const value = e.target.value;
    //console.log(value, product_id, photo_id)
    let selectedQuantity = Array.from(selectedQuantities);
    let new_quantity_array = new Set();
    let new_quantity_object = {};
    if (value !== 0 || value !== 'null') {
      if (selectedQuantity.length === 0) {
        // add object to array 
        new_quantity_object = {
          photo_id: photo_id,
          product_id: product_id, 
          quantity: e.target.value
        };
        new_quantity_array.add(new_quantity_object);
        new_quantity_array = Array.from(new_quantity_array);
        setSelectedQuantities(new_quantity_array)
      } else {
        // first check if photo_id already exist
        if (selectedQuantity.find(p => p.photo_id === photo_id) !== undefined) {
                  // if already exist, replace with new value
                  new_quantity_object = {
                    photo_id: photo_id,
                    product_id: product_id, 
                    quantity: e.target.value
                  };
                  const existingObjectIndex = findIndex(selectedQuantity, selectedQuantity.find(f => f.photo_id === photo_id)); 
                  if (existingObjectIndex !== -1) {
                    selectedQuantity.splice(existingObjectIndex, 1, new_quantity_object);
                    setSelectedQuantities(selectedQuantity);
                  }
        } else {
              // if not just add object to array
              new_quantity_object = {
                photo_id: photo_id,
                product_id: product_id, 
                quantity: e.target.value
              };
              let update_quantity_array = new Set(selectedQuantity);
              update_quantity_array.add(new_quantity_object);
              update_quantity_array = Array.from(update_quantity_array);
              setSelectedQuantities(update_quantity_array);
        }
      }
    } else {
      // replace object if one exist with this photo_id
      if (selectedQuantities.find(p => p.photo_id === photo_id) !== undefined) { 
        new_quantity_object = {
          photo_id: photo_id,
          product_id: product_id, 
          quantity: 'null'
        };
        const existingObjectIndex = findIndex(selectedQuantity, selectedQuantity.find(f => f.photo_id === photo_id)); 
        selectedQuantity.splice(existingObjectIndex, 1, new_quantity_object);
        setSelectedQuantities(selectedQuantity);
      }
    }
  }

  function addSelectionToCart() {
    let selection = new Set();
    selectedPhotos.map(p => selection.add(selectedProducts.find(f => p.id === f.photo_id)))
    const add_to_cart = Array.from(selection);
    if (add_to_cart[0] !== undefined) {

      let newData = new Set();
      add_to_cart.map((p) => {

        const cartItem = {
          session_id: localStorage.getItem("session_id"),
          site_id: localStorage.getItem("site_id"),
          product_categorie: p.productdetail.productcategory.naam,
          product_id: p.product_id,
          login_name: ['professionalphotographer', ''],
          combivel_id: p.productdetail.combivel_id,
          product_name: p.productdetail.naam,
          product_variation: '',
          product_format: p.productdetail.formaat,
          product_file: p.productdetail.product_file,
          shippingcost: p.productdetail.shippingcost,
          photo_id: p.photo_id,
          totaalprijs: p.productdetail.prijs,
          oorspronkelijke_prijs_ps: p.productdetail.prijs,
          prijs_ps: p.productdetail.actie_prijs,
          image_effect: selectedEffect.find(f => f.photo_id === p.photo_id && f.product_id === p.product_id) !== undefined && selectedEffect.find(f => f.photo_id === p.photo_id && f.product_id === p.product_id).effect !== 'null' ? selectedEffect.find(f => f.photo_id === p.photo_id && f.product_id === p.product_id).effect : null,
          amount: selectedQuantities.find(f => f.photo_id === p.photo_id && f.product_id === p.product_id) !== undefined && selectedQuantities.find(f => f.photo_id === p.photo_id && f.product_id === p.product_id).quantity !== 'null' ? selectedQuantities.find(f => f.photo_id === p.photo_id && f.product_id === p.product_id).quantity : null,
          effect_file_name: null,
          effect_file_id: null,
          shoppingcart_rules: []
        };
        return newData.add(cartItem);
      });
      newData = Array.from(newData);
      if (!loadingCreateShoppingCart ) {
        alert('Ramon');
        createShoppingcart({
            variables: {
              input: newData
           }
        })
      }
    }
  }

  const checkQuantities = useCallback((p) => {
    if (selectedQuantities.length > 0) {
      if (selectedQuantities.find(f => f.photo_id === p.id) !== undefined) {
        if (selectedQuantities.find(f => f.photo_id === p.id).quantity !== 'null') {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }, [selectedQuantities])

  const checkProducts = useCallback((p) => {
    if (selectedProducts.length > 0) {
      if (selectedProducts.find(f => p.id !== 'null' && p.id === f.photo_id) !== undefined ) {
        if (selectedProducts.find(f => p.id !== 'null' && p.id === f.photo_id).product_id !== undefined) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }, [selectedProducts])

  useEffect(() => {
    console.log(selectedPhotos);
    let disable_button = true;
    if (selectedProducts.length === 0 && selectedPhotos.length === 0 && selectedQuantities.length === 0){
      disable_button = true;
    }
    if (selectedPhotos.length > 0) {

      selectedPhotos.map(p => {
        const quantity_value = checkQuantities(p);
        const products_value = checkProducts(p);
        return disable_button = (quantity_value || products_value);
      })
      const products_2_value = selectedPhotos.map(a => 
        selectedProducts.length > 0 ? 
          selectedProducts.find(f => a.id !== 'null' && a.id === f.photo_id) === undefined
          : true 
      ).find(f => f === true) !== undefined
      disable_button = (disable_button || products_2_value);

    } else {
      disable_button = true;
    }
    setDisableButton(disable_button);
  }, [selectedPhotos, selectedQuantities, selectedProducts, checkProducts, checkQuantities])

  if (loadingPhotos) return <p>{props.t("Loading...")}</p>;
  if (errorPhotos) return <p>{props.t("Looks like we have a problem...")}</p>;
  if (!data) return null;


  console.log(data);

  return (
    <Grid>
      <Grid container direction="row" spacing={1}>
        <UserToolBar credits={credits} totalCredits={totalCredits} addCredits={addCredits} addCreditsToCart={addCreditsToCart}/>
      </Grid>
      <Grid container direction="row" spacing={1}>
        {data.map((photo) => (
          <Grid item xs={12} sm={8} md={6} lg={4} xl={2} key={photo.id}>
            <LightgalleryProvider>
            <PhotoCard 
              data={photo}
              photos={data}
              updatePhotoSelection={updatePhotoSelection} 
              selectedPhotos={selectedPhotos} 
              disableSelection={disableSelection} 
              setSelectedProducts={setSelectedProducts}
              addEffectToProduct={addEffectToProduct}
              addQuantityToProduct={addQuantityToProduct}
              selectedProducts={selectedProducts}
              selectedEffect={selectedEffect}
              selectedQuantities={selectedQuantities}
            />
            </LightgalleryProvider>
          </Grid>
        ))}
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <GeneralButton 
          className="nav-button mt-2"
          startIcon={<KeyboardBackspaceIcon color="inherit" />}
          >        
            <NavLink exact to={`/`}>
              Ga terug
            </NavLink>
          </GeneralButton>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} style={{textAlign: 'end'}}>sss
            <GeneralButton 
              style={{width: 'auto'}}
              className="nav-button mt-2"
              disabled={disableButton}
              onClick={() => addSelectionToCart()}
              endIcon={ <Badge badgeContent={selectedPhotos.length} overlap="circle" color="secondary" showZero>
                <AddShoppingCartIcon color="inherit" />
                </Badge>
              }
            > 
                Toevoegen aan winkelwagen!
            </GeneralButton>
        </Grid>
      </Grid>
      {pageInfo !== undefined && (
        <TablePagination
          className="overflow-hidden flex-shrink-0"
          component="div"
          count={pageInfo.total ? pageInfo.total : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </Grid>
  );
}

export default React.memo(withTranslation("photos")(AlbumPhotos));
